var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-button",on:{"click":_vm.clickHandler}},[_vm._v("\n    RESET\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }